import React, { useCallback } from 'react';
import { Dropdown } from 'rsuite';

import { useFormBuilderStore } from '../../../pages/builder/state';
import { useModal } from '../../../components/modal';
import { useTracking } from '../../../hooks';
import { fillIds } from '../../../pages/builder/helpers';

import { ImportJsonSchemaModal } from './import-json-schema-modal';

const ImportJSONSchemaMenuItem = () => {
  const tracking = useTracking();
  const setFormValue = useFormBuilderStore(state => state.setFormValue);
  const setDefaultValues = useFormBuilderStore(state => state.setDefaultValues);
  const setForm = useFormBuilderStore(state => state.setForm);
  const setSidebar = useFormBuilderStore(state => state.setSidebar);
  const setEditMode = useFormBuilderStore(state => state.setEditMode);
  const setField = useFormBuilderStore(state => state.setField);
  const setGeneration = useFormBuilderStore(state => state.setGeneration);
  const form = useFormBuilderStore(state => state.form);

  const { open: openImportCode, close: closeImportCode } = useModal({
    view: ImportJsonSchemaModal,
    size: 'lg',
    name: 'import_form',
    align: 'center',
    labelSubmit: null,
    labelCancel: null,
    title: 'Import JSON Schema'
  });

  const handleImport = useCallback(
    async () => {
      tracking.sendEvent('form.import-json-schema');
      const importedForm = await openImportCode();
      await closeImportCode();
      if (importedForm) {
        if (importedForm.type === 'import') {
          const newForm = {
            ...importedForm.form,
            fields: fillIds(importedForm.form.fields)
          };
          setFormValue({});
          setDefaultValues(undefined);
          setForm(newForm);
          setField(null);
          setSidebar('form');
          setEditMode(true);
          setGeneration(generation => generation + 1);
        } else if (importedForm.type === 'merge') {
          const newForm = {
            ...importedForm.form,
            fields: [
              ...(form.fields || []),
              ...fillIds(importedForm.form.fields)
            ]
          };
          setFormValue({});
          setDefaultValues(undefined);
          setForm(newForm);
          setField(null);
          setSidebar('form');
          setEditMode(true);
          setGeneration(generation => generation + 1);
        }

      }
    },
    [form, tracking, openImportCode, closeImportCode, setFormValue, setDefaultValues, setForm, setField, setSidebar, setEditMode, setGeneration]
  );

  return (
    <Dropdown.Item onSelect={handleImport}>Import JSON Schema</Dropdown.Item>
  );
};

export { ImportJSONSchemaMenuItem };
